import { useMemo } from "react";
import useNewDataFetcher from "../../../../Hooks/newUseDataFetcher";
import GraphTable from "../../../../Components/GraphTable";
import SubheaderTimePeriod from "../../../../Components/SubheaderTimePeriod";
import { formatNumber } from "../../../../Utilities/formatting";

function ValueOverTime() {
  const dataURL = "/api/v1/result/placements/value-over-time"
  const { data, dateRange, filterTypes, filters, isReady } = useNewDataFetcher({
    endPoint: dataURL,
  });

  const average = useMemo(() => {
    if (!data) return 0;
    let total = 0;
    let placements = 0;
    data.data.forEach((row) => {
      total += row.total;
      placements += row.numberOfPlacements;
    });
    return Math.round(total / placements);
  }, [data]);

  return (
    <GraphTable data={data} dateRange={dateRange} filterTypes={filterTypes} filters={filters} isReady={isReady} interval={dateRange.interval} dataURL={dataURL}>
      <h1 className="page-heading">How is our mix of placement value changing?</h1>
      <h2 className="page-subheading">
        $<span className="page-data">{formatNumber(average)}</span> average placement value <SubheaderTimePeriod data={dateRange} />
      </h2>
    </GraphTable>
  );
}

export default ValueOverTime;
